import { createDeleteStowagePlanChange } from 'src/factory/Stowage/StowagePlanChanges/StowagePlanChangeFactory';
import { AdjustedCargoTemperature } from 'src/types/ViewModel/Stowage/AdjustedCargoTemperature';
import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';
import { StowageChangeDataType } from 'src/types/ViewModel/Stowage/Enums/StowageChangeDataType';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { StowagePlanChange } from 'src/types/ViewModel/Stowage/StowagePlanChange';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import {
    createFullTemperatureChangeData,
    createTemperatureOnlyChangeData,
} from 'src/factory/Stowage/StowagePlanChanges/StowageChangeData/AdjustedCargoTemperatureChangeDataFactory';

export const getAdjustedCargoTemperature = (stowagePlan: StowagePlan, cargo: RotationCargo): AdjustedCargoTemperature => {
    return stowagePlan.adjustedCargoTemperatures.find((o) => o.cargoGuid === cargo.cargoGuid && !o.tank);
};

export const getAdjustedCargoTemperatureInTank = (stowagePlan: StowagePlan, cargo: RotationCargo, tank: Tank | null): AdjustedCargoTemperature => {
    return stowagePlan.adjustedCargoTemperatures.find((o) => o.cargoGuid === cargo.cargoGuid && o.tank?.tankId === tank?.tankId);
};

export const getAdjustedCargoTemperaturesInTanks = (stowagePlan: StowagePlan, cargo: RotationCargo): AdjustedCargoTemperature[] => {
    return stowagePlan.adjustedCargoTemperatures.filter((o) => o.cargoGuid === cargo.cargoGuid && o.tank);
};

export const updateAdjustedCargoTemperature = (stowagePlan: StowagePlan, adjustedCargoTemperature: AdjustedCargoTemperature) => {
    const existingAdjustedCargoTemperature = stowagePlan.adjustedCargoTemperatures.find(
        (o) => o.cargoGuid === adjustedCargoTemperature.cargoGuid && o.tank?.tankId === adjustedCargoTemperature.tank?.tankId
    );

    let changedData;
    const adjustedCargoTemperatureGuid = existingAdjustedCargoTemperature?.adjustedCargoTemperatureGuid ?? crypto.randomUUID();

    if (existingAdjustedCargoTemperature) {
        existingAdjustedCargoTemperature.temperature = adjustedCargoTemperature.temperature;
        changedData = createTemperatureOnlyChangeData(adjustedCargoTemperature.temperature);
    } else {
        adjustedCargoTemperature.adjustedCargoTemperatureGuid = adjustedCargoTemperatureGuid;
        changedData = createFullTemperatureChangeData(adjustedCargoTemperature);
    }

    return { adjustedCargoTemperatureGuid, changedData };
};

export const removeAdjustedCargoTemperaturesWithoutStowage = (stowagePlan: StowagePlan) => {
    const stowagePlanChanges: StowagePlanChange[] = [];
    stowagePlan.adjustedCargoTemperatures = stowagePlan.adjustedCargoTemperatures.reduce((acc, a) => {
        if (!a.tankId || stowagePlan.stowageItems.some((s) => s.cargoOperation.cargoGuid === a.cargoGuid && s.tankId === a.tankId)) {
            acc.push(a);
        } else {
            stowagePlanChanges.push(
                createDeleteStowagePlanChange(
                    stowagePlan.stowagePlanGuid,
                    a.adjustedCargoTemperatureGuid,
                    StowageChangeDataType.AdjustedCargoTemperature
                )
            );
        }
        return acc;
    }, []);

    return stowagePlanChanges;
};
